import { paymentMethods } from '../../../types';
import { setItem } from '../../../utils/storage';

export const setPaymentMethodInStorage = (paymentMethod: string | null, paymentType: string | null) => {
  const customerPaymentMethod =
    paymentMethod &&
    [paymentMethods.scheme, paymentMethods.giftcard, paymentMethods.groupklarna].includes(paymentMethod)
      ? paymentMethod
      : paymentType;

  setItem('CUSTOMER_PAYMENT_METHOD', customerPaymentMethod, true, 'localStorage');
};
